export default function replaceUrl(url) {
  window.history.replaceState(null, null, url);
}

export function copyToClipboard(text) {
  if ('clipboard' in navigator) {
    return navigator.clipboard.writeText(text);
  }
  if ('clipboardData' in navigator) {
    return window.clipboardData.setData(text);
  }
  return document.execCommand('copy', true, text);
}

export function getUrlPathName() {
  return window.location.pathname;
}

export function getSafeCallbackUrl(callbackUrl, fallback = '/') {
  if (!callbackUrl) return fallback;

  try {
    const url = new URL(callbackUrl, window.location.origin);

    // Block javascript:, data:, vbscript:, etc.
    if (url.protocol !== 'https:' && url.protocol !== 'http:') {
      return fallback;
    }

    // Block cross-origin redirects (open redirect protection)
    if (url.origin !== window.location.origin) {
      return fallback;
    }

    // Return only the path + query + hash (never a full external URL)
    return url.pathname + url.search + url.hash;
  } catch {
    return fallback;
  }
}
